import { route } from "../../service/routeDictionary";
import API from "../../service/api";
import { environment } from "../../environments/env";

const state = {};

const getters = {};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async getMediaByPagination({ commit }, data) {
    if (data.name.length > 0) {
      return await API.get(
        `${environment.apiUri}${route.InstagramMedia}?limit=${data.limit}&caption=${data.name}&Offset=${data.offset}&sort=-timestamp`
      );
    } else {
      return await API.get(
        `${environment.apiUri}${route.InstagramMedia}?limit=${data.limit}&Offset=${data.offset}&sort=-timestamp`
      );
    }
  },
  async getAgendadaByPagination({ commit }, data) {
    if (data.name.length > 0) {
      return await API.get(
        `${environment.apiUri}${route.InstagramMediaSchedule}?limit=${data.limitAgendada}&caption=${data.name}&Offset=${data.offsetAgendada}&sort=-timestamp`
      );
    } else {
      return await API.get(
        `${environment.apiUri}${route.InstagramMediaSchedule}?limit=${data.limitAgendada}&Offset=${data.offsetAgendada}&sort=-timestamp`
      );
    }
  },

  async getAgendada({ commit }, data) {
    return await API.get(
      `${environment.apiUri}${route.InstagramMediaSchedule}`
    );
  },
};
const mutations = {};

export default {
  state,
  actions,
  getters,
  mutations,
};
